// Categorias de documentos do processo (client_docs.type). Os ids são os mesmos do
// backoffice; a ordem aqui é a ordem das abas.
const data = [
    { id: 1, name: 'Principais Documentos' },
    { id: 4, name: 'PRJ e Aditivos' },
    { id: 2, name: 'Relatórios Mensais de Atividades' },
    { id: 3, name: 'Atas' },
    { id: 5, name: 'Relatório de Cumprimento do Plano' },
    { id: 6, name: 'Relação de Credores' },
    { id: 7, name: 'QGC' },
    { id: 8, name: 'Editais' },
    { id: 9, name: 'Autos de Arrecadação e Leilão' }
];

const RECOVERY_CATEGORIES = [1, 4, 2, 3, 5, 6, 7, 8];
const BANKRUPTCY_CATEGORIES = [1, 6, 7, 8, 9];
const EXTRAJUDICIAL_TYPE = 5;
const RECOVERY_TYPES = [1, EXTRAJUDICIAL_TYPE];

// Abas da natureza do processo, mais qualquer categoria que já tenha documentos.
export const getClientDocTypes = (clientType, documents = []) => {
    const base = RECOVERY_TYPES.includes(Number(clientType))
        ? RECOVERY_CATEGORIES
        : BANKRUPTCY_CATEGORIES;
    const used = documents.map((document) => Number(document.type));

    return data
        .filter((item) => base.includes(item.id) || used.includes(item.id))
        .map((item) =>
            item.id === 4 && Number(clientType) === EXTRAJUDICIAL_TYPE
                ? { ...item, name: 'Plano e Aditivos' }
                : item
        );
};

export default [...data];
